import SideBarOptions from "base/src/utils/SideBarOptions"
import { UsuarioResponse } from "../usuario/usuarioResponse"
import { ReduxViewProps } from "base/src/view/states/reduxView"

export const UTIL_SISTEMAID = 'UTIL_SISTEMAID'
export const UTIL_SIDEBAR_IGNORE = 'UTIL_SIDEBAR_IGNORE'
export const UTIL_HEADER_IGNORE = 'UTIL_HEADER_IGNORE'
export const UTIL_AUTH_IGNORE = 'UTIL_AUTH_IGNORE'
export const UTIL_AUTH_IGNORE_REMOVE = 'UTIL_AUTH_IGNORE_REMOVE'
export const UTIL_START_STATE = 'UTIL_START_STATE'
export const UTIL_SIDEBARLIST_STATE = 'UTIL_SIDEBARLIST_STATE'

export const UTIL_USERDATA_STATE = 'UTIL_USERDATA_STATE'

export const UTIL_REDUXVIEW_STATE = 'UTIL_REDUXVIEW_STATE'

export const UTIL_DEVSIMULATE_STATE = 'UTIL_DEVSIMULATE_STATE'

export const UTIL_ROUTE = 'UTIL_ROUTE'
export const UTIL_ROUTE_STATE = 'UTIL_ROUTE_STATE'

export interface ConditionalRoute{
    Path : string,
    Status : boolean,
}


export interface UtilState {
    SistemaID : number | undefined
    SideBarIgnore: string[]
    HeaderIgnore: string[]
    AuthIgnore: string[]
    StartState:boolean
    SideBarList: SideBarOptions[] | undefined
    UserData: UsuarioResponse | undefined
    ReduxView: ReduxViewProps
    DevSimulate: boolean
    ConditionalRoute: ConditionalRoute[]
}

export interface UtilSistemaIDAction {
    type: typeof UTIL_SISTEMAID,
    payload: number | undefined
}

export interface UtilSideBarIgnoreAction {
    type: typeof UTIL_SIDEBAR_IGNORE,
    payload: string
}

export interface UtilHeaderIgnoreAction {
    type: typeof UTIL_HEADER_IGNORE,
    payload: string
}

export interface UtilAuthIgnoreAction {
    type: typeof UTIL_AUTH_IGNORE,
    payload: string
}

export interface UtilAuthIgnoreRemoveAction {
    type: typeof UTIL_AUTH_IGNORE_REMOVE,
    payload: string
}

export interface UtilStartStateAction {
    type: typeof UTIL_START_STATE,
    payload: boolean
}

export interface UtilSideBarListAction {
    type: typeof UTIL_SIDEBARLIST_STATE,
    payload: SideBarOptions[]
}

export interface UtilUsuarioAction {
    type: typeof UTIL_USERDATA_STATE,
    payload: UsuarioResponse
}

export interface UtilReduxViewAction {
    type: typeof UTIL_REDUXVIEW_STATE,
    payload: ReduxViewProps
}

export interface UtilDevSimulateAction {
    type: typeof UTIL_DEVSIMULATE_STATE,
    payload: boolean
}

export interface UtilRouteAction {
    type: typeof UTIL_ROUTE,
    payload: ConditionalRoute
}

export interface UtilRouteStateAction {
    type: typeof UTIL_ROUTE_STATE,
    payload: ConditionalRoute
}

export type UtilActionTypes = UtilSistemaIDAction | UtilSideBarIgnoreAction | UtilHeaderIgnoreAction | UtilAuthIgnoreAction | UtilStartStateAction | UtilAuthIgnoreRemoveAction | UtilSideBarListAction | UtilUsuarioAction | UtilReduxViewAction | UtilDevSimulateAction | UtilRouteAction | UtilRouteAction | UtilRouteStateAction;